/**
 * Created by Ivan on 30.07.2024
 */

const StickersComponent = cc.Node.extend({
    ctor: function (collection) {
        this._super();

        const styles = cleverapps.styles.StickersComponent;

        this.collection = collection;
        const stickers = this.stickers = this.createStickers(collection.stickers);

        const layout = new cleverapps.GridLayout(stickers, {
            columns: cleverapps.resolution.mode !== cleverapps.WideMode.HORIZONTAL ? 3 : 5,
            margin: styles.layout.margin[cleverapps.resolution.mode]
        });
        layout.setAlignment(styles.layout);

        if (styles.fg) {
            const fg = new cc.Scale9Sprite(bundles.stickers_collection_window.frames.foreground_png);
            fg.setContentSize2(styles.fg.size);

            fg.addChild(layout);
            fg.setAlignment(styles.position);

            this.addChild(fg);
            this.setAlignment(styles.position);
            this.setContentSize2(fg.getContentSize());
            fg.setAlignment(this.width / 2, this.height / 2);
        } else {
            this.addChild(layout);
            this.setContentSize2(layout.getContentSize());
            this.setAlignment(styles.layout);
            layout.setAlignment(this.width / 2, this.height / 2);
        }
    },

    createStickers: function (stickers) {
        return stickers.map((sticker) => {
            const ViewClass = sticker.getViewClass();
            const stickerView = new ViewClass(sticker, {
                withUpdate: true,
                badge: true,
                tape: cleverapps.styles.StickerView.tape
            });

            return stickerView;
        });
    },

    onClose: function () {
        this.collection.resetAttention();
    }
});

cleverapps.styles.StickersComponent = {
    position: [
        { x: { align: "center" }, y: { align: "center", dy: -52 } },
        { x: { align: "center" }, y: { align: "center", dy: -52 } },
        { x: { align: "center" }, y: { align: "center", dy: -71 } }
    ],

    fg: {
        size: [
            { width: 900, height: 1070 },
            { width: 900, height: 1070 },
            { width: 1500, height: 750 }
        ]
    },

    layout: {
        margin: [{ x: 30, y: 10 }, { x: 30, y: 10 }, { x: 40, y: 20 }],
        x: { align: "center" },
        y: { align: "center" }
    }
};